import { DiscoveryHorizontalList } from "../../discovery/v2/components/DiscoveryHorizontalList";
import { SpotlightListCollectionCard } from "./SpotlightListCollectionCard";

export const SpotlightListCollection = ({
  pageIds,
  title,
  type,
  onClick,
}: {
  pageIds: string[];
  title: string;
  type: "product style" | "regional";
  onClick?: () => void;
}) => {
  return (
    <>
      <DiscoveryHorizontalList
        title={title}
        onClick={onClick ? () => onClick() : undefined}
        hideViewMore={!onClick}
      >
        {pageIds.map((pageId, index) => (
          <SpotlightListCollectionCard
            pageId={pageId}
            key={index}
            type={type}
          />
        ))}
      </DiscoveryHorizontalList>
    </>
  );
};
